<template>
  <div>
    <!-- O Vue Router renderiza aqui os componentes da rota atual -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
